console.log('Loading bundles_tools...');
var iso2 = 'ES';
if(document.getElementById("loc-iso2")) {
  iso2 = document.getElementById("loc-iso2").getAttribute('content');
}
// var get_bundles_url = 'https://niar.es/get_bundle.php';
// var get_draft_order_url = 'https://niar.es/?action=checkout&lang='+document.documentElement.lang+'&mk='+iso2;

// const get_bundles_url = 'https://pango-bundles-coupon.cap.pangostudio.com/api/get_bundle';
// const get_formatted_cart_url = 'https://pango-bundles-coupon.cap.pangostudio.com/api/cart_formatter?lang='+document.documentElement.lang+'&mk='+iso2;
// const get_draft_order_url = 'https://pango-bundles-coupon.cap.pangostudio.com/api/checkout?lang='+document.documentElement.lang+'&mk='+iso2;

const get_bundles_url = 'https://pango-bundles-coupon.stgcap.pangostudio.com/api/get_bundle';
const get_formatted_cart_url = 'https://pango-bundles-coupon.stgcap.pangostudio.com/api/cart_formatter?lang='+document.documentElement.lang+'&mk='+iso2;
const get_draft_order_url = 'https://pango-bundles-coupon.stgcap.pangostudio.com/api/checkout?lang='+document.documentElement.lang+'&mk='+iso2;


function minimalism_bundles_get_page() {
  /* Devuelvo el primer segmento de la url */
  return window.location.pathname.includes("cart")
}

function minimalism_bundles_get_ids_from_cart(cart) {
  var string_ids = '';
  cart.items.forEach(function(item) {
    //console.log(item)
    string_ids += ',' + item.id
  })
  return string_ids;
}

/* Cookies */
function setCookie(name,value,hours) {
    var expires = "";
    if (hours) {
        var date = new Date();
        date.setTime(date.getTime() + (hours*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

/* Cookies */


function isCheckoutButton(e) {
  console.log('target');
  console.log(e.target);
                    if (e.form) {
                      console.log(e.form);
                        var n = e.form.getAttribute("action");
                        if (null != n) {
                            if (-1 !== n.search(/^\/checkout\b/)) return !0;
                            if (-1 !== n.search(/^\/cart\b/) && "checkout" === e.getAttribute("name")) return !0;
                            var r = t.getPath(n);
                            if (-1 !== r.search(/^\/checkout\b/)) return !0;
                            if (-1 !== r.search(/^\/cart\b/) && "checkout" === e.getAttribute("name")) return !0
                        }
                    }
                    return !1
}

function minimalism_bundles_isUpdate(e) {
  var content = e.target.getAttribute("name");
  if(content) {
    if(content.search(/^\/update\b/)) {
      console.log('A 200 con un Golf');
      return 1;
    }
    else  {
      return !1;
    }
  }
}

function minimalism_bundles_setCheckoutListener() {
  document.addEventListener("click", function(n) {
    //n.preventDefault();
    //console.log(isCheckoutButton(n));
    /*if(minimalism_bundles_isUpdate(n)){
      //Aquí deberíamos actualizar el carrito a ver si hay un bundle
      console.log('Es update');
    }
    else */
    if(isCheckoutButton(n)){
      n.preventDefault();
      console.log('Añadir al carrito, ');
      
    }

                           /* var r = t.getFormFromTarget(n),
                                i = t.getATagFromTarget(n);
                            if (t.isCheckoutButton(r) && e.isDraftOrderMethod()) {
                                var o = t.getCartParams(r);
                                if (o) {
                                    var a = document.createElement("INPUT");
                                    a.type = "HIDDEN", a.name = "query_strings", a.value = o, r.form.appendChild(a)
                                }
                                r.form.action = "/tools/shappify-pb/v2/create_draft_order";
                                var s = t.getCookie("cart"),
                                    u = document.createElement("INPUT");
                                u.type = "HIDDEN", u.name = "cart_id", u.value = s, r.form.appendChild(u), e.addDefaultCurrencyToForm(r.form), e.addCartCurrencyToForm(r.form)
                            } else if (t.isCheckoutLink(i) && e.isDraftOrderMethod()) {
                                n.preventDefault();
                                var l = e.addForm(i);
                                l.submit()
                            }*/
   })
}















/*Modificar carrito, un infierno*/
if(minimalism_bundles_get_page()) {
  jQuery.getJSON('/cart.js', function(cart) {
  //Cojo el carrito actual
    console.log('TEST');
  var ids_items_array = [];
  var ids_items_variants_array = [];
  var items = cart.items;
  //var items_variants = cart.items;
  //Recorremos los productos del carrito y cogemos el id de producto y el id de variante
  items.forEach(function(element) {
    for(var i = 1; i <= element.quantity ; i++) {
      ids_items_array.push(element.product_id);
      ids_items_variants_array.push(element.variant_id);
    }
  });
  

  //NO SE EJECUTA
  //lo meto en una función para no comentar todo el código
  function nohaceNada(){
    var ids_items = ids_items_array.join(',');////
    var ids_variants = ids_items_variants_array.join(',');//
    if(!localStorage.addedBundles) {
      var addedBundles = [];
    }
    else {
      var addedBundles = JSON.parse(localStorage.addedBundles);//
    }
    var id_bundles = addedBundles.join(',');//
    console.log('Justo antes de la llamada');
    //jQuery.get(get_bundles_url +'&ids='+ ids_items+'&ids_variants='+ ids_variants+'&ids_bundles='+addedBundles, function(data) {//
    jQuery.post( get_bundles_url + '?ids=' + minimalism_bundles_get_ids_from_cart(cart) + '&mk=' + iso2, {items : items}, function( data ) { //lo original de moñoño
      var bundle_data = JSON.parse(data);
      console.log( "Bundle encontrado Antes: ", bundle_data, data );
      /*PARA d*/
      items.forEach(it => {
        for(let i in bundle_data){
          for(let bi in bundle_data[i]){
            if(bundle_data[i][bi].product_id == it.product_id){
              if(bundle_data[i][bi].variant_id == it.variant_id) { 
                //it.quantity = it.quantity + 1;
                if(bundle_data[i][bi].quantity != it.quantity) {
                  let sobra = it.quantity - bundle_data[i][bi].quantity;
                  console.log('Sobran ' + sobra)
                  jQuery.post('/cart/change.js', { quantity: bundle_data[i][bi].quantity, id: it.variant_id });
                  jQuery.post('/cart/add.js', {
                    items: [
                      {
                        quantity: sobra,
                        id: it.variant_id,
                        properties: {
                          'TEST' : 'TEST'
                        }
                      }
                    ]
                  });
                }
              }
            }
          }
        }
      });
      /*PARA d*/
    }); 
  }
});


jQuery.getJSON('/cart.js', function(cart) {  
  //pasamos por get el id de los productos bundles que están en la sesión (REVISAR SI SOLO GUARDA UNO O GUARDA VARIOS)
  //jQuery.post( get_bundles_url + '?ids=' + minimalism_bundles_get_ids_from_cart(cart), {items : items1}, function( data ) {
   
  var ids_items_array = [];
  var items_variants_array = [];
  var items = cart.items;
  var items_variants = cart.items;
  let variant_per_line = [];
  items.forEach(function(element) {
    variant_per_line.push(element.variant_id);
    for(var i = 1; i <= element.quantity ; i++) {
      ids_items_array.push(element.product_id);
      items_variants_array.push(element.variant_id);
    }
  });

  //Esta es la función que nos devuelve el símbolo en función del market
  var moneda = getSymbolCurrency(cart.currency);
  let filasDeProductos = jQuery('.cart-item-list__body > .merge > .cart-item');
  let var_info = {};
  filasDeProductos.each(function( index ) {
      var_info[variant_per_line[index]] = {
      "original_class" : filasDeProductos[index].className,
      "linkOriginal" : filasDeProductos[index].children[0].children[0].href,
      "weird_img" : filasDeProductos[index].children[0].children[0].children[0].children[0].children[0],
      "noscript" : filasDeProductos[index].children[0].children[0].children[0].children[0].children[1].innerHTML,
      "name" : filasDeProductos[index].children[1].children[0].children[0].children[0].innerHTML,
      "variant" : filasDeProductos[index]?.children[1]?.children[0]?.children[0]?.children[1]?.children[0]?.innerHTML ?? "",
      "linkQuitar" : filasDeProductos[index].children[1].children[2].children[1].href,
      "orginal_quantity" : filasDeProductos[index].children[1].children[2].children[0].children[1].value,
    };
  });
  
  

  
  var ids_items = ids_items_array.join(',');
  var ids_variants = items_variants_array.join(',');
  if(!localStorage.addedBundles) {
    var addedBundles = [];
  }
  else {
    var addedBundles = JSON.parse(localStorage.addedBundles);
  }
  var id_bundles = addedBundles.join(',');

  let totalPrecioCarrito = 0;
  
  jQuery.get(get_formatted_cart_url +'&ids='+ ids_items+'&ids_variants='+ ids_variants+'&ids_bundles='+id_bundles, function(data) {
    jQuery('.cart-item-list__body > .merge').children().hide();
    data.forEach((variant, i)=>{
      let unitPrice = parseFloat(variant.unit_price);
      let quantity = parseInt(variant.quantity);
      let product_data = var_info[variant.variantId];
      let linkOriginalSplited = product_data.linkQuitar.split('&');
      let relativeLink = linkOriginalSplited[0]+'&quantity='+(parseInt(product_data.orginal_quantity) - quantity);
      let linksuma = linkOriginalSplited[0]+'&quantity='+(parseInt(product_data.orginal_quantity) + 1);
      let linkresta = linkOriginalSplited[0]+'&quantity='+(parseInt(product_data.orginal_quantity) - 1);
      let classunusable = '';
      let bundleTitle = '';

      totalPrecioCarrito += unitPrice * quantity;
      if(variant.bundle_title){
        bundleTitle = "<p class=\"bundle-name\">" + variant.bundle_title + "</p>";
      }
      
      if(quantity === 1){
        classunusable = 'unusable';
      }

      console.log(variant)
      
      let newRow = getNewRow(product_data.original_class,product_data.linkOriginal,product_data.weird_img,product_data.noscript,product_data.name,product_data.variant,unitPrice,quantity,quantity * unitPrice,product_data.linkQuitar,linkOriginalSplited,relativeLink,linksuma,linkresta,classunusable,moneda,i + 1,bundleTitle)
      jQuery(newRow).insertAfter(".cart-item-list__body > .merge > .cart-item:last");
    })

    //Cambiamos el precio total del carrito según las modificaciones que hemos hecho
    let totalPrecioCarritoLabel = jQuery('.subtotal > span');
    totalPrecioCarritoLabel.text(totalPrecioCarrito.toFixed(2) + " " + moneda);

    $( ".quantity-up" ).click(function(evt) {
      if(evt.currentTarget.id != 'fake'){
        upDown(evt.currentTarget.href);
      }
    });
    
    $( ".quantity-down" ).click(function(evt) {
      if(evt.currentTarget.id != 'fake'){
        upDown(evt.currentTarget.href);
      }
    });
    
  });
});
}

validateQty = function(t) {
  return (parseFloat(t) !== parseInt(t) || isNaN(t)) && (t = 1), t
}
/*

Capturar el evento submit del formulario del carrito
/cart

*/
jQuery("[name='checkout']").click(function(event) {
  console.log('hellong');
  event.preventDefault();
  jQuery.getJSON('/cart.js', function(cart) {
    //console.log('pinto carrito');
    //console.log(cart);
    jQuery("[name='checkout']").attr("disabled", "disabled");
    var ids_items_array = [];
    var items_variants_array = [];
    var items = cart.items;
    var items_variants = cart.items;
    items.forEach(function(element) {
      //console.log(element.product_id);
      //console.log(element.quantity);
      for(var i = 1; i <= element.quantity ; i++) {
        ids_items_array.push(element.product_id);
        items_variants_array.push(element.variant_id);
      }
    });
    var ids_items = ids_items_array.join(',');
    var ids_variants = items_variants_array.join(',');
    if(!localStorage.addedBundles) {
      var addedBundles = [];
    }
    else {
      var addedBundles = JSON.parse(localStorage.addedBundles);//
    }
    var id_bundles = addedBundles.join(',');
    let coupon_url = '';
    //Revisamos si la cookie existe
    let cookieCouponExists = document.cookie.split(';')
      .some(row => row.trim().startsWith('pango-coupon='));
    if(cookieCouponExists) {
      //si existe pillamos el valor para enviarlo al checkout
      var cookieCouponValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('pango-coupon='))
      .split('=')[1];
      coupon_url = '&cp='+cookieCouponValue;
    }
    
    jQuery.getJSON('https://api.db-ip.com/v2/free/self', function(geoInfo) {

      jQuery.get(get_draft_order_url +'&ids='+ ids_items+'&ids_variants='+ ids_variants+'&ids_bundles='+addedBundles+coupon_url+'&ip_user='+geoInfo['ipAddress'], function(data) {
        data = JSON.parse(data);
        
        if(data.url) {
          location.href = data.url;
        }
      });
    }).fail(
      function () {
        jQuery.get(get_draft_order_url +'&ids='+ ids_items+'&ids_variants='+ ids_variants+'&ids_bundles='+addedBundles+coupon_url, function(data) {
          data = JSON.parse(data);
          
          if(data.url) {
            location.href = data.url;
          }
        });
      }
    );
    
  /*jQuery.post( get_draft_order_url, {'cart' : cart, 'bundles_ids' : getCookie('minimalism-bundles-parent-id')}, function( data ) {
    var response = JSON.parse(data);
    console.log('pinto response bro');
    console.log(response);
    if(response.url) {
      location.href = response.url;
    }
    
  });*/
  });
});

//minimalism_bundles_setCheckoutListener();
//Si no ha fallado...
console.log('Minimalsim Bundles App loaded');





///LLLLL


function getSymbolCurrency(param) {
  var symbol = "";
  switch (param) {
  case "EUR":
    symbol = "€";
    break;
  default:
    symbol = param;
  }

  return symbol;
}

function getNewRow(original_class,linkOriginal,weird_img,noscript,name,variant,precio_unitario,cantidad,preciototal,linkQuitar,linkOriginalSplited,relativeLink,linksuma,linkresta,classunusable,moneda,index,bundleTitle){
  return `<div class="${original_class}"><div class="cart-item__column cart-item__image">
          <a href="${linkOriginal}">
          <div class="rimage-outer-wrapper" style="max-width: 57px">
          <div class="rimage-wrapper " style="padding-top:175.0%">
          <img 
            class="${weird_img.className}"
            data-widths="${weird_img.dataset.widths}"
            data-aspectratio="${weird_img.dataset.aspectratio}"
            data-sizes="${weird_img.dataset.sizes}"
            data-srcset="${weird_img.dataset.srcset}"
            sizes="${weird_img.sizes}"
            srcset="${weird_img.srcset}"
            alt="${weird_img.alt}"
          >
            <noscript>
              ${noscript}
            </noscript>
          </div>
        </div>
          </a>
        </div>

        <div class="cart-item__not-image">
          <div class="cart-item__column cart-item__description">
            <div>
              <a class="name" href="${linkOriginal}">${name}</a>
              ${ bundleTitle }
              <div class="small-text">
                <div class="variant">${variant}</div>
              </div>
            </div>
          </div>

          <div class="cart-item__column cart-item__price">
            <div><span class="theme-money">${moneda} ${precio_unitario.toFixed(2)}</span></div>
          </div>

          
          <div class="cart-item__column cart-item__quantity">
            <div class="quantity buttoned-input">
              <a id="fake" class="notabutton quantity-down ${classunusable}" onclick="upDown('${linkresta}')" aria-label="Reducir"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><title>Menos</title><line x1="5" y1="12" x2="19" y2="12"></line></svg></a>
              <input type="text" size="2" value="${cantidad}" aria-label="Cantidad">
              <a id="fake" class="notabutton quantity-up " onclick="upDown('${linksuma}')" aria-label="Aumentar"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><title>Más</title><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg></a>
            </div>
            <a class="remove" onclick="return confirm('¿Seguro que deseas eliminar este artículo de tu orden?')" href="${relativeLink}">
              Quitar
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </a>
          </div>
          <div class="cart-item__column cart-item__total" data-line="${index}">
              <span class="theme-money">${moneda} ${preciototal.toFixed(2)}</span> 
          </div>
        </div>
      </div>`;
}

function upDown(link){
  window.location.href = link;
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

$('#minimalism-add-to-cart').on( 'click', function() {
  let oldLink = $('.cart-link').attr('href');
  sleep(800).then(() => {
    $('.cart-link').attr('href',oldLink);
  });
} );